"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const createNewDripping_1 = __importDefault(require("./createNewDripping"));
const drippingCard_1 = __importDefault(require("./drippingCard"));
const drippingTable_1 = __importDefault(require("./drippingTable"));
const mapStateToProps = (stores) => ({
    isMobile: stores.UiStore.isMobile
});
const DrippingList = ({ drippings, isMobile, onEditClick, onRemoveClick }) => {
    if (drippings.length === 0) {
        return null;
    }
    if (isMobile) {
        return ((0, jsx_runtime_1.jsxs)("section", { children: [(0, jsx_runtime_1.jsx)("ul", { className: "_list-style-none _p-0", children: drippings.map((dripping) => ((0, jsx_runtime_1.jsx)(drippingCard_1.default, { dripping: dripping, onRemoveClick: onRemoveClick, onEditClick: onEditClick }, dripping.key))) }), (0, jsx_runtime_1.jsx)(createNewDripping_1.default, { onClick: onEditClick })] }));
    }
    return ((0, jsx_runtime_1.jsx)(drippingTable_1.default, { drippings: drippings, onEditClick: onEditClick, onRemoveClick: onRemoveClick }));
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(DrippingList);
